import React, { use, useContext, useEffect, useState } from "react";

import { Row, Col } from "../Grid";
import { Container, Line, Tag, Tags, TagText, TagTitle, Title } from "./styles";
import Icon from "../Icon";
import FitinsurAPI from '../../utils/src/fitinsur-api'

const DocumentTagList = ({
  idQuestion,
  questionnaire = [],
  setQuestionnaire,
  removeTag, 
  showRemoveIcon, 
  idOperation, 
  requestExpireDocument, 
  authContext
}) => {
    const [documents, setDocuments] = useState([]);
    
    const [rows, setRows] = useState([]);
    const columns = [
        { key: "documentType", order: 1, visible: true},
        { title: "Relevant To", order: 2, visible: true},
        { title: "Which Insurer", order: 3, visible: true }, 
        { title: "Actions", order: 4, visible: false }
    ]

    useEffect(() => {
      const answerDocuments = questionnaire.find((question) => question.idQuestion === idQuestion)?.answer;

      setDocuments(answerDocuments || []);
    }, [questionnaire, idQuestion]);

    useEffect(() => {
      if (!documents || !documents.length || typeof documents === 'string') return;

      const documentTypeObject = documents?.reduce((acc, doc) => {
        const type = doc.documentType.idAnswerOption;
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push(doc);
        return acc;
      }, {});
      

      const newRows = Object.entries(documentTypeObject).map(([idAnswerOption, docs]) => {
        const newColumns = columns.map(column => ({
          ...column,
          title: column.key ? docs[0][column.key]?.dsAnswerOption || "" : column.title,
        }));

        return {
          idAnswerOption,
          columns: newColumns,
          docs
        }
      });

      setRows(newRows);
      
    }, [documents, documents.length]);


    useEffect(() => {
      console.log('documents', documents);
    }, [documents, documents.length]);

    if (!Array.isArray(documents)) return <></>;

    if (!documents.length) return <></>;
    
    function removeDocumentAnswer({ documentId}) {
      const updatedQuestionnaire = questionnaire.map((question) => {
        if (question.idQuestion === idQuestion) {
          const updatedAnswer = question.answer.filter((doc) => doc.documentId !== documentId);

          return {
            ...question,
            answer: updatedAnswer,
            answerJson: updatedAnswer
          };
        }
        return question;
      });

      setQuestionnaire(updatedQuestionnaire);
    };

    function expireDocuments(idOperation, idDocument) {
      const fitinsur = new FitinsurAPI();
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestExpireDocument(Number(idOperation), idDocument)
        .then((data) => console.log(data));
    };

    return (
        <Container>
          {rows.map((row, index) => (
            <div key={index}>
              <Tags>
                {row.columns.map((column, colIndex) => (
                    (index === 0 || colIndex === 0 ) && (
                      <Col key={colIndex}>
                        <Title>{column.visible && column.title}</Title>
                      </Col>  
                    )
                ))}
              </Tags>

              {row.docs.map((doc, docIndex) => (
                <Tags key={docIndex}> 
                  <Col> 
                    <Tag>
                      <TagTitle href={doc.fileUrl} target="_blank">
                        {doc.fileName}
                      </TagTitle>
                    </Tag>
                  </Col>

                  <Col>
                    <TagText>{doc.relevantTo?.dsRelevantTo}</TagText>
                  </Col>

                  <Col>
                    <TagText>{doc.whichInsurer?.dsWhichInsurer}</TagText>
                  </Col>

                  {showRemoveIcon && (
                    <Col>
                      <Icon 
                        name="trash"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          removeDocumentAnswer({ 
                            documentId: doc.documentId 
                          });
                          // expireDocuments(idOperation, doc.documentId);
                        }}
                      />
                    </Col>
                  )}
                </Tags>
              ))}
            </div>
          ))}
         
          <Line/>
        </Container>
    )
}

export default DocumentTagList;